import { FirebaseApp } from '@angular/fire/app';

/** Minimal shape read from the `ENVIRONMENT` token by this helper. */
export interface FunctionsUrlEnvironment {
  emulator?: boolean;
  firebase?: { projectId?: string };
}

/**
 * Base URL of the HTTP Cloud Functions (region `europe-west1`).
 *
 * The `projectId` comes from the **initialized** Firebase app, never from the
 * build-time environment: `apps/app` resolves its Firebase config at runtime
 * (dev/pro toggle — 10 taps on the menu version write `localStorage['environment']`,
 * see `apps/app/src/environments/firebase-config.ts`). Reading the raw
 * environment made these URLs hit the dev project while the rest of the SDK
 * (Firestore, Auth, Storage, callable Functions) talked to production.
 *
 * `environment.firebase.projectId` is kept only as a defensive fallback for the
 * (theoretical) case where the app options carry no projectId.
 */
export function resolveFunctionsBaseUrl(
  app: FirebaseApp | null | undefined,
  environment: FunctionsUrlEnvironment | null | undefined,
): string {
  const projectId =
    app?.options?.projectId ?? environment?.firebase?.projectId;

  if (environment?.emulator) {
    return `http://localhost:5001/${projectId}/europe-west1/`;
  }
  return `https://europe-west1-${projectId}.cloudfunctions.net/`;
}
